import CheckboxPrimitive from './CheckboxPrimitive';
import { CheckboxPrimitiveTypes } from './CheckboxPrimitive.interfaces';

export default CheckboxPrimitive;
export { CheckboxPrimitive, CheckboxPrimitiveTypes };
